import IntervalTree from '@flatten-js/interval-tree'
import moment from 'moment-timezone'

const memberEventsTreeForDate = (memberEvents, currentDate, timezone) => {
  currentDate.startOf('day')
  const memberEventsForCurrentDate = new IntervalTree()
  memberEvents.forEach((memberEvent) => {
    const memberEventStart = moment.tz(memberEvent.start, timezone)
    const memberEventEnd = moment.tz(memberEvent.end, timezone)
    if (memberEventStart.isSame(currentDate, 'day')) {
      memberEventsForCurrentDate.insert(
        [memberEventStart.unix(), memberEventEnd.unix()],
        memberEvent
      )
    } else {
      const multipeDaysEventOverlaps = !memberEventStart.isSame(memberEventEnd, 'day')
        && memberEventStart.clone().startOf('day').isBefore(currentDate)
        && memberEventEnd.clone().startOf('day').isSameOrAfter(currentDate)
      if (multipeDaysEventOverlaps) {
        const endOfEvent = moment.min(memberEventEnd, moment(currentDate).endOf('day'))
        memberEventsForCurrentDate.insert(
          [currentDate.unix(), endOfEvent.unix()],
          memberEvent
        )
      }
    }
  })
  return memberEventsForCurrentDate
}

const memberEventsTree = (memberEvents, timezone) => {
  const tree = new IntervalTree()
  memberEvents.forEach((memberEvent) => {
    const memberEventStart = moment.tz(memberEvent.start, timezone)
    const memberEventEnd = moment.tz(memberEvent.end, timezone)
    tree.insert(
      [memberEventStart.unix(), memberEventEnd.unix()],
      memberEvent
    )
  })
  return tree
}

export {
  memberEventsTree,
  memberEventsTreeForDate
}
